export default {
  resize (map, timeout) {
    if (map === null) {
      return
    }
    setTimeout(() => { map.getViewPort().resize() }, timeout)
  },

  clearMap (map) {
    if (map === null) {
      return
    }

    map.getObjects().forEach(object => {
      map.removeObject(object)
    })
  },

  setBounds (map, points, adjustBuffer) {
    if (map === null) {
      return
    }
    let maxLat = -90
    let minLat = 90
    let maxLng = -180
    let minLng = -90

    for (let i = 0; i < points.length; i++) {
      let coords = points[i]
      if (coords.lat > maxLat) { maxLat = coords.lat }
      if (coords.lat < minLat) { minLat = coords.lat }
      if (coords.lng > maxLng) { maxLng = coords.lng }
      if (coords.lng < minLng) { minLng = coords.lng }
    }

    let buffer = 0.4
    if (adjustBuffer) {
      buffer = adjustBuffer
    }
    let latBuffer = (maxLat - minLat) * buffer
    let lngBuffer = (maxLng - minLng) * buffer

    let group = new window.H.map.Group()
    group.addObjects([
      new window.H.map.Marker({ lat: minLat - latBuffer, lng: maxLng + lngBuffer }),
      new window.H.map.Marker({ lat: maxLat + latBuffer, lng: minLng - lngBuffer })
    ])

    let box = group.getBoundingBox()
    map.getViewModel().setLookAtData({ bounds: box }, true)
  },

  removeObject (map, id) {
    if (map === null) {
      return
    }

    map.getObjects().forEach(object => {
      if (object.id === id) {
        map.removeObject(object)
        return
      }
    })
  },

  adjustStyle (map) {
    let provider = map.getBaseLayer().getProvider()
    let style = provider.getStyle()
    console.log('J', style)
  }
}



// WEBPACK FOOTER //
// ./src/components/Runs/_map-utils.js